import { If, TabLink } from "components";
import { useBoolean } from "hooks";
/* eslint-disable react-hooks/exhaustive-deps */
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { Routes } from "modules/common";
import {
  EarningChapters,
  Earnings,
  BalanceLabel,
  PayAllEarningsModal,
  useEarningsQuantities,
  useMobileMoneyBalance
} from "modules/financial";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "ui";

import styles from "./EarningsPage.module.scss";

const EarningsPage = () => {
  const earningsRoutes = Routes.find((route) => {
    return route.label === "Financial";
  })?.nestedRoutes?.find((route) => {
    return route.label === "Earnings";
  })?.nestedRoutes;

  const { earningsQuantities, refetch: refetchEarningsQuantities } =
    useEarningsQuantities();

  const { balance } = useMobileMoneyBalance();

  const { activeTab } = useParams();

  const [isPayAllBtnDisabled, setIsPayAllBtnDisabled] = useState(false);

  const {
    value: isPayAllEarningsModalOpen,
    setTrue: openPayAllEarningsModal,
    setFalse: closePayAllEarningsModal
  } = useBoolean(false);

  const getTabCounterValueByLabel = (label: string) => {
    switch (label) {
      case "Pending":
        return earningsQuantities?.pending ?? 0;
      case "Ready to Pay":
        return earningsQuantities?.availableToBePaid ?? 0;
      case "Paid":
        return earningsQuantities?.paid ?? 0;
      case "Canceled":
        return earningsQuantities?.canceled ?? 0;
      default:
        return 0;
    }
  };

  useEffect(() => {
    void refetchEarningsQuantities();
  }, [activeTab]);

  return (
    <ContentLayout
      title={t("Earnings")}
      action={
        <div className={styles.pageContent_action}>
          {activeTab === EarningChapters.AvailableToBePaid ? (
            <Button
              onClick={openPayAllEarningsModal}
              disabled={isPayAllBtnDisabled}
            >
              {t("Pay all")}
            </Button>
          ) : null}
          <BalanceLabel label="Wave balance" balance={balance} />
        </div>
      }
    >
      <BoxShadowLayout className={styles.pageContent}>
        <If condition={!!earningsRoutes}>
          <nav>
            {earningsRoutes?.map((route) => (
              <TabLink
                key={route.label}
                pathName={route.path}
                label={route.label}
                counterValue={getTabCounterValueByLabel(route.label)}
              />
            ))}
          </nav>
        </If>

        <Earnings setIsPayAllBtnDisabled={setIsPayAllBtnDisabled} />
      </BoxShadowLayout>

      <PayAllEarningsModal
        isOpen={isPayAllEarningsModalOpen}
        onClose={closePayAllEarningsModal}
      />
    </ContentLayout>
  );
};

export default EarningsPage;
